import { ComponentInterface, forceUpdate, getElement } from '@stencil/core';

/**
 * Slot PropertyDecorator
 * @todo is this needed anymore? this was used for early versions of edge < 17 to fix visibility of slots at loading
 * @param name
 * @constructor
 */
export const Slot = (name?: string) => {
  return (proto: ComponentInterface, _propertyKey: string | symbol) => {
    // catch the original callbacks for later hooks
    const { componentWillRender, componentWillUpdate } = proto;

    const updateComponent = function (reference) {
        // we need this timeout to trick the async render process, it works every time and is safe
        setTimeout(() => {
          // call force update to rerender the component for the current reference
          forceUpdate(reference);
          // eslint-disable-next-line no-magic-numbers
        }, 10);
      },
      handleNodes = function (reference, nodes: NodeList) {
        for (let i = 0; i < nodes.length; i++) {
          const _node = nodes[i];
          // do we have a node with attributes?
          if (_node.nodeType === Node.ELEMENT_NODE) {
            // does it have a slot assigned?
            if ((_node as Element).hasAttribute('slot')) {
              // so we update the component
              updateComponent(reference);
            }
          }
        }
      },
      observeHostAndSlots = function (reference) {
        // catch the stencil element/component of the current reference
        const component = getElement(reference),
          // do we have a slot with the given name by the decorator? if so we catch it
          slot =
            component !== undefined && component != null
              ? name
                ? component.querySelector('[slot=' + name + ']')
                : component.querySelector('slot')
              : false,
          // observer options
          options = {
            attributes: false,
            characterData: false,
            childList: true,
            subtree: true,
            attributeOldValue: false,
            characterDataOldValue: false,
          };

        // create namespace if needed to register new slot mutation observer
        if (reference.__slots === undefined) {
          reference.__slots = {};
        }

        // do we have a slot and is it not already referenced with a mutation observer?
        if (slot && !reference[_propertyKey]) {
          // filter slots that are empty and without real content, we do not need them
          component[_propertyKey] = reference[_propertyKey] =
            Array.from(
              // @ts-expect-error migrated from ts-ignore
              slot.childNodes.length == 0 ? (slot.assignedNodes ? slot.assignedNodes() : []) : slot.childNodes,
            ).filter((node) => {
              // @ts-expect-error migrated from ts-ignore
              return node.textContent.trim() !== '' || node.childNodes.length > 0;
            }).length > 0
              ? slot
              : undefined;
          // create mutation observer for slot name on reference
          reference.__slots[_propertyKey] = new MutationObserver((mutations) => {
            mutations.forEach(() => {
              updateComponent(reference);
            });
          });

          // register an observer to the current slot
          reference.__slots[_propertyKey].observe(slot, options);
        }

        // do we have a host mutation observer listen for new nodes on host element?
        if (!reference.__host) {
          // create mutation observer for host on reference
          // important to catch dynamic render process changes in react or angular
          reference.__host = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              handleNodes(reference, mutation.addedNodes);
              handleNodes(reference, mutation.removedNodes);
            });
          });

          // register an observer to the component
          reference.__host.observe(component, options);
        }
      };

    // hook into will update
    proto.componentWillUpdate = function () {
      observeHostAndSlots(this);

      // call the original callback with the right scope
      return componentWillUpdate && componentWillUpdate.call(this);
    };

    // hook into will render
    proto.componentWillRender = function () {
      observeHostAndSlots(this);

      // call the original callback with the right scope
      return componentWillRender && componentWillRender.call(this);
    };
  };
};
